import type { StyleLayer } from './utils/types'

export const layers_roads_mainstreets: StyleLayer[] = [
  {
    id: 'roadclassification_motortrunk copy',
    type: 'line',
    filter: [
      'match',
      ['get', 'road'],
      ['motorway', 'motorway_link', 'trunk', 'trunk_link'],
      true,
      false,
    ],
    minzoom: 7.7,
    paint: {
      'line-color': '#828282',
      'line-width': ['interpolate', ['linear'], ['zoom'], 11, 1, 14, 1.5, 16, 2],
    },
  },
  {
    id: 'roadclassification_mainstreets copy',
    type: 'line',
    filter: [
      'match',
      ['get', 'road'],
      ['primary', 'primary_link', 'secondary', 'secondary_link', 'tertiary', 'tertiary_link'],
      true,
      false,
    ],
    minzoom: 7.7,
    paint: {
      'line-color': '#f6e7ac',
      'line-width': [
        'interpolate',
        ['linear'],
        ['zoom'],
        11,
        [
          'match',
          ['get', 'road'],
          ['primary', 'secondary', 'secondary_link', 'primary_link'],
          5,
          ['tertiary', 'residential_priority_road', 'tertiary_link'],
          3.5,
          0.8,
        ],
        14,
        [
          'match',
          ['get', 'road'],
          ['primary', 'secondary', 'secondary_link', 'primary_link'],
          10,
          ['tertiary', 'residential_priority_road', 'tertiary_link'],
          8,
          0.8,
        ],
        16,
        [
          'match',
          ['get', 'road'],
          ['primary', 'secondary', 'secondary_link', 'primary_link'],
          24,
          ['tertiary', 'residential_priority_road', 'tertiary_link'],
          16,
          0.8,
        ],
      ],
    },
  },
  {
    id: 'hitarea-roadclassification copy 1',
    type: 'line',
    filter: [
      'match',
      ['get', 'road'],
      [
        'primary',
        'tertiary_link',
        'secondary_link',
        'tertiary',
        'secondary',
        'primary_link',
        'trunk',
        'motorway_link',
        'motorway',
        'trunk_link',
      ],
      true,
      false,
    ],
    layout: {
      'line-cap': 'round',
    },
    paint: {
      'line-color': 'rgb(216, 20, 255)',
      'line-opacity': 0,
      'line-width': ['interpolate', ['linear'], ['zoom'], 9, 1, 14.1, 10, 22, 12],
    },
  },
]
